import { c as _c } from "react/compiler-runtime";
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useConstructionSiteUsageStatisticTools } from '../../../classes/entities/ConstructionSiteUsageStatistic/useConstructionSiteUsageStatisticTools';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { ConstructionSiteToSelectListItemProps } from '../../constructionSite/ConstructionSiteToSelectListItem/ConstructionSiteToSelectListItem';
export function useConstructionSiteSelectedHandler() {
  const $ = _c(6);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const usageStatisticTools = useConstructionSiteUsageStatisticTools();
  let t0;
  if ($[0] !== dispatch || $[1] !== navigate || $[2] !== usageStatisticTools) {
    t0 = constructionSite => {
      usageStatisticTools.usedConstructionSite(constructionSite);
      dispatch(createWorkTimeEntrySlice.actions.setConstructionSiteId(constructionSite.id));
      navigate(RoutePaths.createWorkTimeEntry());
    };
    $[0] = dispatch;
    $[1] = navigate;
    $[2] = usageStatisticTools;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleConstructionSiteSelected = useEventCallback(t0);
  let t1;
  if ($[4] !== handleConstructionSiteSelected) {
    t1 = {
      handleConstructionSiteSelected
    };
    $[4] = handleConstructionSiteSelected;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}